export default {
  metaInfo () {
    return {
      script: [{
        id: 'google-places-script',
        src: `https://maps.google.com/maps/api/js?key=${process.env.VUE_APP_GOOGLE_API_KEY}&libraries=places&language=${this.$i18n.locale}`,
        async: true,
        defer: true,
        callback: () => this.googlePlacesInitFn()
      }]
    }
  },
  data() {
    return {
      autocomplete: undefined,
      autocomplete2: undefined,
      orderCountryOptions: [],
      form: {
        is_company: false,
        company_name: '',
        tax_id: '',
        salutation: 'Mr.',
        first_name: '',
        last_name: '',
        street: '',
        zip: '',
        city: '',
        country_id: '',
        phone: '',
        email: '',
        email_confirmation: '',
        password: '',
        password_confirmation: '',
        shipping_address: false,
        shipping_company_name: '',
        shipping_salutation: 'Mr.',
        shipping_first_name: '',
        shipping_last_name: '',
        shipping_address_street: '',
        shipping_address_zip: '',
        shipping_address_city: '',
        shipping_address_country: '',
        shipping_address_phone: '',
      },
      validation: {},
    };
  },
  computed: {
    confirmStreetState() {
      return this.$store.getters.CONFIRM_STREET_STATE;
    },
    personalData() {
      return this.checkout.personalData;
    },
    authType() {
      return this.checkout.authType;
    },
    formCountryId() {
      return this.form.country_id;
    },
    formDiffCountryId() {
      return this.form.shipping_address_country;
    },
  },
  watch: {
    formCountryId(id, oldId) {
      if (oldId && id !== oldId) {
        const countryOption = this._.find(this.countryOptions, {id});
        const country = countryOption && countryOption.iso_code ? countryOption.iso_code : null;

        if (this.autocomplete && country) {
          this.autocomplete.setOptions({
            types: ['geocode'], componentRestrictions: {country}
          });
        }
      }
    },
    formDiffCountryId(id, oldId) {
      if (oldId && id !== oldId) {
        const countryOption = this._.find(this.countryOptions, {id});
        const country = countryOption && countryOption.iso_code ? countryOption.iso_code : null;

        if (this.autocomplete2 && country) {
          this.autocomplete2.setOptions({
            types: ['geocode'], componentRestrictions: {country}
          });
        }
      }
    },
    personalData(personalData) {
      if (personalData && typeof personalData !== 'object') {
        let checkout = this.checkout;
        checkout.personalData = false;

        this.$store.dispatch('SET_CHECKOUT', checkout);

        if (!this.confirmStreetState && (!this.form.shipping_address && this.form.street && this.form.zip && this.form.city || this.form.shipping_address && this.form.shipping_address_street && this.form.shipping_address_zip && this.form.shipping_address_city)) {
          const country_id = this.form.shipping_address ? this.form.shipping_address_country : this.form.country_id;

          this.showConfirmAddressModal({
            address: this.form.shipping_address
                ? this.form.shipping_address_street
                : this.form.street,
            zip: this.form.shipping_address
                ? this.form.shipping_address_zip : this.form.zip,
            city: this.form.shipping_address
                ? this.form.shipping_address_city : this.form.city,
            country: this._.find(this.countryOptions, {id: country_id}).name
          });
        } else {
          this.onSubmit();
        }
      }
    },
  },
  methods: {
    initCountry() {
      const firstCountry = this._.first(this.orderCountryOptions);

      this.form.country_id = firstCountry.id;
      this.form.shipping_address_country = firstCountry.id;
    },
    async initOrderCountryOptions() {
      const loader = this.$loading.show();

      try {
        const cart = JSON.stringify(this.cart);
        const countries = await this.axios.post('v2/countries/get_by_shop',
            {cart});

        this.orderCountryOptions = countries.data && countries.data.data
            ? countries.data.data : [];

        loader.hide();

        if (this.orderCountryOptions.length > 0) {
          this.initCountry();
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
    setFormFromCheckout() {
      this.form = this.checkout.personalData;
    },
    setFormFromLocalStorage() {
      this.form = JSON.parse(localStorage.getItem('checkout-personal-data'));
    },
    initProfileData() {
      this.form.salutation = this.user.salutation || this.form.salutation;
      this.form.first_name = this.user.first_name;
      this.form.last_name = this.user.last_name;
      this.form.street = `${this.user.street}`; /*, ${this.user.house_number}*/
      this.form.zip = this.user.zip;
      this.form.city = this.user.city;
      //this.form.country_id = this.user.country_id;
      this.form.phone = this.user.phone;
      this.form.shipping_address = !!parseInt(
          this.user.is_different_delivery_address);
      this.form.shipping_first_name = this.user.shipping_first_name;
      this.form.shipping_last_name = this.user.shipping_last_name;
      this.form.shipping_address_street = `${this.user.shipping_address_street}`; /*, ${this.user.shipping_address_house_number}*/
      this.form.shipping_address_zip = this.user.shipping_address_zip;
      this.form.shipping_address_city = this.user.shipping_address_city;
      //this.form.shipping_address_country = this.user.shipping_address_country;
    },
    initValidation() {
      this.validation = {
        company_name: {
          valid: null,
          message: '',
        },
        first_name: {
          valid: null,
          message: '',
        },
        last_name: {
          valid: null,
          message: '',
        },
        street: {
          valid: null,
          message: '',
        },
        zip: {
          valid: null,
          message: '',
        },
        city: {
          valid: null,
          message: '',
        },
        country_id: {
          valid: null,
          message: '',
        },
        email: {
          valid: null,
          message: '',
        },
        email_confirmation: {
          valid: null,
          message: '',
        },
        password: {
          valid: null,
          message: '',
        },
        password_confirmation: {
          valid: null,
          message: '',
        },
        phone: {
          valid: null,
          message: '',
        },
        shipping_first_name: {
          valid: null,
          message: '',
        },
        shipping_last_name: {
          valid: null,
          message: '',
        },
        shipping_address_street: {
          valid: null,
          message: '',
        },
        shipping_address_zip: {
          valid: null,
          message: '',
        },
        shipping_address_city: {
          valid: null,
          message: '',
        },
        shipping_address_country: {
          valid: null,
          message: '',
        },
      };
    },
    async onSubmit() {
      this.initValidation();

      const loader = this.$loading.show();

      try {
        let response;
        const data = {
          form: this.form,
          cart: JSON.stringify(this.cart),
        };

        if (this.tmpOrder) {
          response = await this.axios.put(
              `v2/temp-order/${this.authType}/${this.tmpOrder.id}`, data);
        } else {
          response = await this.axios.post(
              `v2/temp-order/${this.authType}`, data);
        }

        if (response.data.success) {
          response.data.data.flags = response.data.flags;
          this.$store.dispatch('SET_TMP_ORDER', response.data.data);

          if (!this.user && response.data.email_exists) {
            this.showExistingEmailModal(this.form.email, response.data);
          } else {
            this.next(response.data);
          }

          const checkout = this.checkout;
          checkout.personalData = this.form;

          localStorage.setItem('checkout-personal-data', JSON.stringify(checkout.personalData));

          this.$store.dispatch('SET_CHECKOUT', checkout);
        } else if (response.data.errors.length > 0) {
          response.data.errors.forEach((error) => {
            if (typeof this.validation[error.field] !== 'undefined') {
              this.validation[error.field].valid = false;
              this.validation[error.field].message = error.message;
            }
          });

          if (response.data.message !== '') {
            this.toast(this.$t('error'), response.data.message, 'danger');
          }

          this.$nextTick(() => {
            const invalidField = document.querySelector('.is-invalid');

            if (invalidField) {
              const headerOffset = 150;
              const elementPosition = invalidField.offsetTop;
              const offsetPosition = elementPosition - headerOffset;

              window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
              });
            }
          });
        }

        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
    next(order) {
      this.checkoutAuthProcess(order);
    },
    googlePlacesInitFn() {
      this.$nextTick(() => {
        let country;
        let diffCountry;

        const addressField = document.getElementById('address');
        const diffAddressField = document.getElementById('diff-address');

        const countryOption = this._.find(this.countryOptions, {id: this.form.country_id});
        const diffCountryOption = this._.find(this.countryOptions, {id: this.form.shipping_address_country});

        country = countryOption && countryOption.iso_code ? countryOption.iso_code : null;
        diffCountry = diffCountryOption && diffCountryOption.iso_code ? diffCountryOption.iso_code : null;

        if (!country) {
          const firstCountryOption = this._.first(this.countryOptions);
          country = firstCountryOption && firstCountryOption.iso_code ? firstCountryOption.iso_code : 'AT';
        }

        if (!diffCountry) {
          const firstDiffCountryOption = this._.first(this.countryOptions);
          diffCountry = firstDiffCountryOption && firstDiffCountryOption.iso_code ? firstDiffCountryOption.iso_code : 'AT';
        }

        this.autocomplete = new window.google.maps.places.Autocomplete((addressField), {
          types: ['geocode'], componentRestrictions: {country}
        });

        this.autocomplete2 = new window.google.maps.places.Autocomplete((diffAddressField), {
          types: ['geocode'], componentRestrictions: {country: diffCountry}
        });

        this.autocomplete.addListener('place_changed', () => {
          const place = this.autocomplete.getPlace() || null;

          if (place && place.address_components && place.address_components.length > 0) {
            place.address_components.forEach(component => {
              switch (component.types[0]) {
                case 'postal_code':
                  this.form.zip = component.long_name;
                  break;
                case 'locality':
                  this.form.city = component.long_name;
              }

              this.form.street = place.name;
            });
          }
        });

        this.autocomplete2.addListener('place_changed', () => {
          const place = this.autocomplete2.getPlace() || null;

          if (place && place.address_components && place.address_components.length > 0) {
            place.address_components.forEach(component => {
              switch (component.types[0]) {
                case 'postal_code':
                  this.form.shipping_address_zip = component.long_name;
                  break;
                case 'locality':
                  this.form.shipping_address_city = component.long_name;
              }

              this.form.shipping_address_street = place.name;
            });
          }
        });
      });
    }
  },
  async created() {
    let infoText;

    switch (this.authType) {
      case 'user':
        infoText = 'auth.sign_in';
        break;
      case 'registration':
        infoText = 'order_with_registration';
        break;
      case 'guest':
        infoText = 'order_as_guest';
        break;
    }

    this.$emit('info', this.$t(infoText));

    this.initValidation();

    await this.initOrderCountryOptions();

    if (this.checkout.personalData && typeof this.checkout.personalData ===
        'object') {
      this.setFormFromCheckout();
    } else if (localStorage.getItem('checkout-personal-data')) {
      this.setFormFromLocalStorage();
    } else if (this.user) {
      this.initProfileData();
    }

    this.$store.commit('SET_CONFIRM_STREET_STATE', false);
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  },
  beforeDestroy() {
    window.google = undefined;
  }
};
